export const BRANDS = {
  GENERIC: 'generic',
  KMX: 'kmx',
  CARGURUS: 'cargurus',
  CARVANA: 'carvana',
  ECHOPARK: 'echopark',
  PEDDLE: 'peddle',
  CASHFORCARS: 'cashforcars',
  CARWISER: 'carwiser',
  ICO: 'ico',
  ICOMODULE: 'icomodule',
  PLUG: 'plug',
  DRIVEWAY: 'driveway',
};

export const ALL_BRANDS = new Set(Object.values(BRANDS));

export const DRIVEWAY_LOGO_FEATURE_FLAG = 'EMO-4478-drivewayLogo';

export const GENERIC_DISCLAIMER =
  "The offer is contingent on your providing accurate information on Edmunds.com. There will be an in-person verification of your vehicle and evaluation of other vehicle use and history information prior to finalizing the offer. Any differences between the information you provide about your vehicle and the vehicle's actual condition, use, and history may affect the offer you receive.";

/**
 * Contains the brands Edmunds is working with (i.e. is getting offers from) currently.
 *
 * @type {(string)[]}
 */
export const CURRENT_BRANDS = [BRANDS.KMX, BRANDS.ECHOPARK, BRANDS.PLUG];

// This array is used to form a list of brands in the lead form disclaimer
export const CURRENT_OFFER_PROVIDERS = [BRANDS.KMX, BRANDS.ECHOPARK, BRANDS.PLUG];

export const getCurrentBrands = ({ isDrivewayLogoEnabled } = {}) =>
  isDrivewayLogoEnabled ? [...CURRENT_BRANDS, BRANDS.DRIVEWAY] : CURRENT_BRANDS;

export const getCurrentOfferProviders = ({ isDrivewayLogoEnabled } = {}) =>
  isDrivewayLogoEnabled ? [...CURRENT_OFFER_PROVIDERS, BRANDS.DRIVEWAY] : CURRENT_OFFER_PROVIDERS;

export const ICO_SOURCES = { MODS: 'MODS', API: 'API' };

// Contains the list of brands whose logos we display in the "our partners" module.
export const BRANDS_LIST = CURRENT_BRANDS.concat(BRANDS.ICO);

export const getBrandsList = ({ isDrivewayLogoEnabled } = {}) =>
  getCurrentBrands({ isDrivewayLogoEnabled }).concat(BRANDS.ICO);
